export const DEFAULT_SLIPPAGE = 1 // 1%
export const MIN_SLIPPAGE = 0.001
export const MAX_SLIPPAGE = 10
export const HIGH_IMPACT_THRESHOLD = 3
